import { ReactElement } from 'react'

import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

interface AdditionalInfoItemProps {
  title: string
  value: string | ReactElement
}

const AdditionalInfoItem: RFC<AdditionalInfoItemProps> = ({
  title,
  value
}) => {
  return (
    <Stack direction="row">
      <Text variant="body2" color="text.third" sx={{ width: 100 }}>
        {title}
      </Text>
      <Text variant="body2">{value}</Text>
    </Stack>
  )
}

export default AdditionalInfoItem
